import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { validateForm } from "../../../../../features/components/customComponents/customValidation/index";
import { Input } from "@mui/material";
import { TextMaskCustom } from "../../../../../app/utils/utils";
import { validate } from "./validations.jsx";

import CircularProgress from "@mui/material/CircularProgress";

import { resetPassword } from '../../../../../app/redux/slices/app/registerSlice';

import CustomSnackbar from "../../../../../features/components/customComponents/CustomSnackbar/index";

const ResetuserPasswordbyAdmin = ({ onClose, editData, clear }) => {
  // console.log("edit", editData);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const contactsList = useSelector(
    (state) => state?.communicationSlice?.contactsList
  );
  const createContactsData = useSelector(
    (state) => state.communicationSlice.createContactsData
  );
  const updateCommunicationData = useSelector(
    (state) => state.communicationSlice.editContactsData
  );

  const loader = updateCommunicationData.loader || createContactsData.loader;
  useEffect(() => {
    if (successMessage) {
      setOpenSnackbar(true);
    }
  }, [successMessage]);

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    password: "",
    confirmPassword: "",
    account_no: "",
    address: "",
  });
  useEffect(() => {
    if (editData?.account_no) {
      setFormData({
        account_no: editData?.account_no,
        name: editData?.name,
        phone: editData?.phone,
        email: editData?.email,
        address: editData?.address,
      });
    }
  }, [editData]);
  const validationRules = {
    email: {
      required: true,
      name: "Email",
      format: /^[^@]+@[^@]+\.[^@]+$/,
    },
    phone: {
      required: true,
      name: "Phone Number",
      minDigits: "10",
    },
  };
  useEffect(() => {
    if (clear) {
      clearform();
    }
  }, [clear]);
  const clearform = () => {
    setErrors({});

    setFormData({
      ...formData,
      name: "",
      phone: "",
      email: "",
      account_no: "",
      password: "",
      confirmPassword: "",
      address: "",
    });
  };
  const updatFormData = (feild, val) => {
    const curFormData = { ...formData };
    curFormData[feild] = val;
    setFormData({ ...curFormData });
    validateForm(formData, validationRules);
  };

  const onValidate = async () => {
    let curFormData = { ...formData };
    const baseErrors = validate(curFormData);
    const combinedErrors = { ...baseErrors };
    setErrors(combinedErrors);
    const noError = Object.keys(combinedErrors).length === 0;
    if (noError) {
        let payload = {
          user_email: formData.email,
          new_password: formData.password,
          old_password: ""
        };
        const passwordRes = await dispatch(resetPassword(payload));
  
        if (passwordRes?.payload?.data?.['is-success']) {
          setSuccessMessage('Password changed successfully!');
          setOpenSnackbar(true);
        } else {
          setSuccessMessage('Error: Old password is incorrect');
          setOpenSnackbar(true);
        }
    }

    return noError;
  };
   
  return (
    <>
      <CustomSnackbar
        openSnackbar={openSnackbar}
        severity={successMessage.includes("Failed") ? "error" : "success"}
        message={successMessage}
        autoHideDuration={1000}
        handleClose={() => {
          setOpenSnackbar(false);
          onClose();
          clearform();
        }}
      />
      <div className="modal-body">
        <form action="" className="mt-4">
          <div className="row">
            <div className="col-lg-6">
              <div className="form-group">
                <label htmlFor="#fname">
                  Full Name <span>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="fname"
                  placeholder="Ex:- John"
                  value={formData.name}
                  onChange={(e) => {
                    updatFormData("name", e.target.value);
                  }}
                  disabled
                  onKeyDown={(e) => {
                    const key = e.key;
                    const isLetter = /^[a-zA-Z ]$/.test(key);
                    const isAllowedKey =
                      isLetter ||
                      key === "Backspace" ||
                      key === "Delete" ||
                      key === "ArrowLeft" ||
                      key === "ArrowRight";

                    if (!isAllowedKey) {
                      e.preventDefault();
                    }
                  }}
                />
                {errors.name && (
                  <span style={{ color: "red" }}>{errors.name}</span>
                )}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form-group">
                <label htmlFor="#lname">
                  Address<span>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="lname"
                  placeholder="Ex:- Smith"
                  value={formData.address}
                  onChange={(e) => {
                    updatFormData("address", e.target.value);
                  }}
                  disabled
                />
                {errors.address && (
                  <span style={{ color: "red" }}>{errors.address}</span>
                )}
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="form-group">
                <label htmlFor="#email">
                  Email <span>*</span>
                </label>
                <input
                  value={formData.email}
                  onChange={(e) => {
                    updatFormData("email", e.target.value);
                  }}
                  type="email"
                  className="form-control"
                  id="email"
                  placeholder="Ex:- example@example.com"
                  disabled
                />
                {errors.email && (
                  <span style={{ color: "red" }}>{errors.email}</span>
                )}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form-group">
                <label htmlFor="#phone">
                  Phone Number<span>*</span>
                </label>
                <Input
                  fullWidth
                  value={formData.phone}
                  onChange={(e) => {
                    updatFormData("phone", e.target.value);
                  }}
                  disableUnderline
                  inputComponent={TextMaskCustom}
                  style={{ backgroundColor: "white" }}
                  disabled
                />
                {errors.phone && (
                  <span style={{ color: "red" }}>{errors.phone}</span>
                )}
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form-group">
                <label>
                  Password <span>*</span>
                </label>
                <div className="input-group password-group">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control"
                    placeholder="Enter password"
                    value={formData.password}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        password: e.target.value,
                      });
                    }}
                  />
                  <span className="input-group-text">
                    <button
                      type="button"
                      className="btn btn-light"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {/* {showPassword ? (
                        <i className="fa fa-eye-slash align-middle" />
                      ) : (
                        <i className="fa fa-eye align-middle" />
                      )} */}
                        <label className='cp'>
                              {showPassword ? "Hide":'Show'
                         }
                          </label>
                    </button>
                  </span>
                </div>
                <div
                  style={{
                    fontSize: "small",
                    color: "red",
                  }}
                >
                  {Array.isArray(errors.password) &&
                    errors.password.map((msg, index) => (
                      <div key={index}>{msg}</div>
                    ))}
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="form-group">
                <label>
                  Confirm Password <span>*</span>
                </label>
                <div className="input-group password-group">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    className="form-control"
                    placeholder="Confirm password"
                    value={formData.confirmPassword}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        confirmPassword: e.target.value,
                      });
                    }}
                  />
                  <span className="input-group-text">
                    <button
                      type="button"
                      className="btn btn-light"
                      onClick={() =>
                        setShowConfirmPassword(!showConfirmPassword)
                      }
                    >
                      {/* {showConfirmPassword ? (
                        <i className="fa fa-eye-slash align-middle" />
                      ) : (
                        <i className="fa fa-eye align-middle" />
                      )} */}
                        <label className='cp'>
                              {showConfirmPassword ? "Hide":'Show'
                         }
                          </label>
                    </button>
                  </span>
                </div>
                <div
                  style={{
                    fontSize: "small",
                    color: "red",
                  }}
                >
                  {errors.confirmPassword && (
                    <div>{errors.confirmPassword}</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div className="modal-footer border-0">
        <div className="d-flex justify-content-end gap-10px">
          <a
            className="btn btn-custom startlit_navy"
            data-bs-dismiss="modal"
            onClick={() => {
              onClose();
              clearform();
            }}
          >
            Close
            
          </a>
          <a
            className="btn btn-custom electric_cobalt"
            onClick={onValidate}
            disabled={loader}
          >
            {!loader ? (
              "Reset Password"
            ) : (
              <CircularProgress color="secondary" size={20} />
            )}
          </a>
        </div>
      </div>
    </>
  );
};
export default ResetuserPasswordbyAdmin;
